"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentAllPages = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));
var _hooks = require("../../hooks");
var _ContentRoot = require("../ContentRoot");
var _ContentText = require("../ContentText");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const ContentAllPages = () => {
  const {
    allPagesPagesContent
  } = (0, _hooks.useFooter)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (!allPagesPagesContent) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContentRoot.ContentRoot, {
    testId: getTestId(_constants.CONTENT_ALL_PAGES),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContentText.ContentText, {
      children: (0, _htmlReactParser.default)((0, _sanitizeHtml.default)(allPagesPagesContent, _constants.sanitizeOptions))
    })
  });
};
exports.ContentAllPages = ContentAllPages;